<div class="recherche-tmdb">
  <form class="search-form">
    <mat-form-field class="search-full-width">
      <mat-label>Recherche cover TMDB</mat-label>
      <input #searchInput matInput placeholder="Recherche cover TMDB" value="" (keydown.enter)="tmdbSearchCoverEnter($event, searchInput.value)" >
      <button mat-button *ngIf="searchInput.value" matSuffix aria-label="Clear" (click)="searchInput.value=''">
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    </mat-form-field>
  </form>
  <button color="primary" class="search-full-width-button" mat-flat-button (click)="tmdbSearchCover(searchInput.value)">Recherche</button>
</div>

<div class="searchResults">
  <mat-progress-spinner *ngIf="loading" class="mat-progress-spinner-tmdbSearch" mode="indeterminate"></mat-progress-spinner>

  <div style="text-align: center">
    <img *ngFor="let tmdbResult of filteredTmdbResults" [src]="tmdbResult.thumb"
         style="margin: 10px; cursor: pointer"
         (click)="selectCover(tmdbResult.cover_image, tmdbResult.year, tmdbResult.title, tmdbResult.media_type)"
         matTooltip="{{ tmdbResult.year }} | {{ tmdbResult.title }} ({{ tmdbResult.media_type }})" matTooltipPosition="above" />
  </div>

  <mat-paginator [length]="tmdbResults.length" [pageSize]="defaultRecords" [pageSizeOptions]="[5, 10, 20]" (page)="pageEvent = $event; onPaginateChange($event)">
  </mat-paginator>
</div>
